export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export function authLogout(payload) {
  return {
    type: AUTH_LOGOUT,
    payload,
  };
}
